import * as Schema from 'owa-graph-schema';

/**
 * Populates the childFolderIds for root folder and all other folders
 * @param rootFolder Root folder in the hierarchy
 * @param otherFolders Other folders in the hierarchy
 * @param foldersToShowFirstUnderRootFolder folders to show first under root folder
 */
export function formParentChildRelationships(
    rootFolder: Schema.MailFolder | null,
    otherFolders: Schema.MailFolder[],
    foldersToShowFirstUnderRootFolder: string[]
) {
    if (!rootFolder) {
        return;
    }

    const folders: { [id: string]: Schema.MailFolder } = {};
    const folderNameIdMap: { [name: string]: string } = {};
    const folderIds: string[] = [];

    folders[rootFolder.FolderId.Id] = rootFolder;
    folderIds.push(rootFolder.FolderId.Id);

    otherFolders.forEach(folder => {
        if (folder) {
            folders[folder.FolderId.Id] = folder;
            folderIds.push(folder.FolderId.Id);
        }
    });

    folderIds.forEach(folderId => {
        const folder = folders[folderId];
        const parentFolderId = folder.ParentFolderId?.Id;

        if (folder.DistinguishedFolderId) {
            folderNameIdMap[folder.DistinguishedFolderId] = folderId;
        }

        // TODO: Parent maybe already fetched and did not come as part of this request, so get from Apollo cache (perhaps need merge)
        const parent = parentFolderId && folders[parentFolderId];

        if (parent) {
            parent.childFolderIds.push(folderId);
        }
    });

    let childIdsForRootFolder: string[] = [];

    // populate childIdsForRootFolder with wellknown folder ids first.
    foldersToShowFirstUnderRootFolder.forEach(folderToShowFirstWellKnownName => {
        const wellknownFolderId = folderNameIdMap[folderToShowFirstWellKnownName];
        if (wellknownFolderId) {
            childIdsForRootFolder.push(wellknownFolderId);
        }
    });

    let ids = rootFolder.childFolderIds || [];
    for (let i = 0; i < ids.length; i++) {
        const id = ids[i] || null;
        if (id && childIdsForRootFolder.indexOf(id) == -1) {
            childIdsForRootFolder.push(id);
        }
    }

    rootFolder.childFolderIds = childIdsForRootFolder;
}
